// Note and Notes are here together instead of their own files because
// they have a circular dependency on each other

import Backbone from 'backbone'

import user from 'scoreboard/components/user'
import _ from 'lodash'

var Notes = Backbone.Collection.extend({})

var Note = Backbone.Model.extend({

	initialize: function(attributes, options) {
		this.section = options && options.section
	},

	urlRoot: function() {
		return 'api/' + this.section + '/' + this.get('domainId') + '/notes'
	},

	replies: function() {
		if (!this._replies) {
			this._replies = new Notes(this.get('replies'))
		}
		return this._replies
	},

	// add or update the given reply
	setReply: function(reply) {
		this.replies().set([reply], { remove: false })
		this.update()
	},

	deleteReply: function(id, domainObject) {
		// tell server to delete the note
		var note = new Note({ id: id, domainId: domainObject.id })
		note.section = domainObject.section
		note.destroy()
		// remove the reply from the collection
		var reply = this.replies().get(id)
		this.replies().remove(reply)
		this.update()
	},

	// update this model with any changes that happened to the replies
	update: function() {
		this.set('replies', this.replies().toJSON())
		this.trigger('update')
	},

	save: function() {
		Backbone.Model.prototype.save.apply(this, arguments)

		let set = {
			lastModifier: _.cloneDeep(user.impersonatorOrUser),
			update: !user.isImpersonationActive
		}

		if (this.isNew()) {
			set.created = new Date()
		} else {
			set.lastModified = new Date()
		}

		this.set(set)
	}

})

Notes.prototype.model = Note

export default Notes
export { Note }

Notes.__filename__ = 'notes/notes.js'
